var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['designing-status', `designing-status--${this.kebabizedStatusname}`]},[_vm._v(" "+_vm._s(_vm.$t(`page.designing.status.${_vm.statusName}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }